import { NotificationService } from '../../notification/swal/notification.service';
import { Component } from '@angular/core';
import { Form } from '../../services/form';
import { ForgetPasswordService } from '../../services/forgetPassword.service';
import RecoveryPasswordModel from './recovery-password.model';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-recovery-password',
  templateUrl: './recovery-password.component.html',
  styleUrls: ['./recovery-password.component.less']
})
export class RecoveryPasswordComponent extends Form {

  recoveryPasswordModel: RecoveryPasswordModel = new RecoveryPasswordModel();
  routeParams: Params;

  constructor(private router: Router, private route: ActivatedRoute,
    private forgetPasswordService: ForgetPasswordService, private notificationService: NotificationService) {
    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  private recoveryPassword() {
    this.recoveryPasswordModel.token = this.routeParams['token'];
    this.recoveryPasswordModel.cpfOuEmail = this.routeParams['cpfOuEmail'];
    this.forgetPasswordService.recoveryPassword(this.recoveryPasswordModel)
      .then(() => {
        this.notificationService.showSuccessNotification('Senha alterada com sucesso!')
          .then(() => {
            this.router.navigate(['/']);
          });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  recoveryPasswordValidation() {
    if (this.getFormStatus()) {
      if (this.recoveryPasswordModel.novaSenha === this.recoveryPasswordModel.confirmacaoNovaSenha) {
        this.recoveryPassword();
      } else {
        this.notificationService.showAlertNotification('As senhas estão diferentes!');
      }
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/recovery-password/recovery-password.component.ts